// extracted by mini-css-extract-plugin
export default {"content":"T6MGOl0y","actions":"PR324fvK"};